import { SurchargeDisputeDataSchema } from "@redotech/redo-model/balance/surcharge-dispute";
import { AdvancedFilterDataSchema } from "@redotech/redo-model/views/views";
import * as z from "zod";

export const getSurchargeDisputes = {
  name: "getSurchargeDisputes" as const,
  input: z.object({
    pageNumber: z.number(),
    pageSize: z.number(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
  }),
  output: z.object({
    disputes: z.array(SurchargeDisputeDataSchema),
    total: z.number(),
  }),
};
